import React from 'react';
import Navbar from '../navbar';

const AuthLoadingCallback = () => {
  return (
    <>
      <Navbar />
      <div className="bg-light py-5 min-vh-100 mt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 col-lg-6">
              <div className="card shadow-sm border-0 rounded-3 text-center p-4">
                <div className="card-body">
                  <div className="spinner-border text-warning mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <h4 className="fw-light mb-2">Completing Secure Sign-In</h4>
                  <p className="text-muted small mb-0">
                    Verifying your credentials and establishing your secure session with Okta. You will be redirected automatically...
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthLoadingCallback;
